import { render } from "./CourseDetail.vue?vue&type=template&id=2434441f&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&lang=js"
export * from "./CourseDetail.vue?vue&type=script&lang=js"

import "./CourseDetail.vue?vue&type=style&index=0&id=2434441f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2434441f"]])

export default __exports__